import {Component, forwardRef, Injector, Input} from '@angular/core';
import {AbstractInput} from '../abstract-input';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextInputComponent)
        }
    ],
    selector: 'vui-text-input',
    styleUrls: ['./text-input.component.scss'],
    templateUrl: './text-input.component.html'
})
export class TextInputComponent extends AbstractInput {
    @Input() public max: number;

    constructor(protected injector: Injector) {
        super(injector);
    }
}
